var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',{staticClass:"header z-ind"},[_c('div',{staticClass:"container mx-auto d-flex"},[_c('router-link',{staticClass:"logo-title",attrs:{"to":"/"}},[_vm._v(" ファイナンシャル・プランニング技能検定２級 ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }